import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 菜单
 */
const menu = {

  /**
   * 创建
   */
  createMenuHouseGroup (name, companyId, subsystemName, loginPassword) {
    return axios.post(base.menu.createMenuHouseGroup, utils.postParamsArrayToJsonString({ name, companyId, subsystemName, loginPassword }))
  },
  /**
   * 修改
   */
  modifyMenuHouseGroup (id, name, loginPassword) {
    return axios.post(base.menu.modifyMenuHouseGroup, utils.postParamsArrayToJsonString({ id, name, loginPassword }))
  },
  /**
   * 查询
   */
  listMenuHouseGroup (companyId, subsystemName) {
    return axios.post(base.menu.listMenuHouseGroup, utils.postParamsArrayToJsonString({ companyId, subsystemName }))
  },
  /**
   * 删除
   */
  deleteMenuHouseGroup (id, loginPassword) {
    return axios.post(base.menu.deleteMenuHouseGroup, utils.postParamsArrayToJsonString({ id, loginPassword }))
  },
  /**
   * 创建
   */
  createMenuHouse (name, iconResourceId, isSystemIcon, groupId, loginPassword) {
    return axios.post(base.menu.createMenuHouse, utils.postParamsArrayToJsonString({ name, iconResourceId, isSystemIcon, groupId, loginPassword }))
  },
  /**
   * 修改
   */
  modifyMenuHouse (id, name, iconResourceId, isSystemIcon, loginPassword) {
    return axios.post(base.menu.modifyMenuHouse, utils.postParamsArrayToJsonString({ id, name, iconResourceId, isSystemIcon, loginPassword }))
  },
  /**
   * 查询
   */
  listMenuHouse (companyId,subsystemName) {
    return axios.post(base.menu.listMenuHouse, utils.postParamsArrayToJsonString({ companyId,subsystemName }))
  },
  /**
   * 删除
   */
  deleteMenuHouse (id, loginPassword) {
    return axios.post(base.menu.deleteMenuHouse, utils.postParamsArrayToJsonString({ id, loginPassword }))
  },
  /**
   * 创建
   */
  createMenu (parentId, name, pageId, pageInstanceName, pageParam, iconResourceId, isSystemIcon, orderNum, companyId,systemName, loginPassword) {
    return axios.post(base.menu.createMenu, utils.postParamsArrayToJsonString({ parentId, name, pageId, pageInstanceName, pageParam, iconResourceId, isSystemIcon, orderNum, companyId,systemName, loginPassword }))
  },
  /**
   * 创建
   */
  createMenu2 (parentId, menus, houseId, loginPassword) {
    return axios.post(base.menu.createMenu2, utils.postParamsArrayToJsonString({ parentId, menus, houseId, loginPassword }))
  },
  /**
   * 修改
   */
  modifyMenu (menuId, parentId, name, pageId, pageInstanceName, pageParam, iconResourceId, isSystemIcon, orderNum, loginPassword) {
    return axios.post(base.menu.modifyMenu, utils.postParamsArrayToJsonString({ menuId, parentId, name, pageId, pageInstanceName, pageParam, iconResourceId, isSystemIcon, orderNum, loginPassword }))
  },
  /**
   * 查看用户菜单
   */
  getMenu (companyId,systemName) {
    return axios.post(base.menu.getMenu, utils.postParamsArrayToJsonString({ companyId,systemName }))
  },
  /**
   * 查看自身菜单
   */
  getMyMenu (companyId,systemName) {
    return axios.post(base.menu.getMyMenu, utils.postParamsArrayToJsonString({ companyId,systemName }))
  },
  /**
   * 删除
   */
  deleteMenu (menuId, loginPassword) {
    return axios.post(base.menu.deleteMenu, utils.postParamsArrayToJsonString({ menuId, loginPassword }))
  },
  /**
   * 新增菜单模板
   */
  addMenuTemplate (name, subsystemName) {
    return axios.post(base.menu.addMenuTemplate, utils.postParamsArrayToJsonString({ name, subsystemName }))
  },
  /**
   * 修改菜单模板
   */
  modifyMenuTemplate (id, name) {
    return axios.post(base.menu.modifyMenuTemplate, utils.postParamsArrayToJsonString({ id, name }))
  },
  /**
   * 查询菜单模板
   */
  getMenuTemplates () {
    return axios.post(base.menu.getMenuTemplates, utils.postParamsArrayToJsonString({}))
  },
  /**
   * 删除菜单模板
   */
  deleteMenuTemplate (id) {
    return axios.post(base.menu.deleteMenuTemplate, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 新增菜单模板项
   */
  addMenuTemplateItem (templateId, name, pageId, pageInstanceName, pageParam, iconResourceId, isSystemIcon, parentId, orderNum) {
    return axios.post(base.menu.addMenuTemplateItem, utils.postParamsArrayToJsonString({ templateId, name, pageId, pageInstanceName, pageParam, iconResourceId, isSystemIcon, parentId, orderNum }))
  },
  /**
   * 新增菜单模板项
   */
  addMenuTemplateItems (templateId, items) {
    return axios.post(base.menu.addMenuTemplateItems, utils.postParamsArrayToJsonString({ templateId, items }))
  },
  /**
   * 修改菜单模板项
   */
  modifyMenuTemplateItem (id, name, pageId, pageInstanceName, pageParam, iconResourceId, isSystemIcon, parentId, orderNum) {
    return axios.post(base.menu.modifyMenuTemplateItem, utils.postParamsArrayToJsonString({ id, name, pageId, pageInstanceName, pageParam, iconResourceId, isSystemIcon, parentId, orderNum }))
  },
  /**
   * 查询菜单模板项
   */
  getMenuTemplateItems (templateId) {
    return axios.post(base.menu.getMenuTemplateItems, utils.postParamsArrayToJsonString({ templateId }))
  },
  /**
   * 删除菜单模板项
   */
  deleteMenuTemplateItems (ids) {
    return axios.post(base.menu.deleteMenuTemplateItems, utils.postParamsArrayToJsonString({ ids }))
  },
}

export default menu